/** Cumulative “load more” slice: pages 1..n visible at once. */
export function sliceCumulativePage<T>(
  items: T[],
  currentPage: number,
  itemsPerPage: number
): T[] {
  const endIndex = currentPage * itemsPerPage;
  return items.slice(0, endIndex);
}

export function hasMoreCumulativePage(
  totalCount: number,
  currentPage: number,
  itemsPerPage: number
): boolean {
  return totalCount > currentPage * itemsPerPage;
}
